/**
 * 构造 resetHeart like 模糊查询。
 * @param searchString
 */
export function like(searchString: string) {
	return { $regex: searchString }
}

/**
 * 构造 resetHeart in 查询。
 * @param values
 */
export function $in(values: any[]) {
	return { $in: values }
}
